<template>
  <div>
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}</v-breadcrumbs-item
          >
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />
    <div>
      <v-layout row v-if="droitAcces.list_mission">
        <v-flex xs3 class="mb-2 mr-1">
          <v-card color="brown darken-1" class="white--text elevation-5">
            <v-container fluid grid-list-lg>
              <v-layout row>
                <v-flex xs6>
                  <div>
                    <div class="display-2">
                      {{ statistique.missAvalide2}}
                    </div>
                    <div>A VALIDER</div>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div>A APPROUVER</div>
                  <div class="display-2">
                      {{statistique.missAvalide1}}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs3 class="mb-2 mr-1">
          <v-card
            color="amber darken-4 darken-2"
            class="white--text elevation-5"
          >
            <v-container fluid grid-list-lg>
              <v-layout row>
                <v-flex xs6>
                  <div>
                    <div class="display-2">
                      {{ statistique.missCloture }}
                    </div>
                    <div>CLOTUREES</div>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div>EN COURS</div>
                  <div class="display-2">
                    {{ statistique.missEncours}}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex xs6 class="mb-2 mr-1">
          <v-card color="cyan darken-2" class="white--text elevation-5">
            <v-container fluid grid-list-lg>
              <v-layout row style="text-align:center">
                <v-flex xs4>
                  <div>FRAIS MISSION EN COURS FCFA</div>
                  <div class="display-1">
                    {{ statistique.totalFrais}}
                  </div>
                </v-flex>
                  <v-flex xs8>
                  <div>TOTAL NOTE DE FRAIS FCFA</div>
                  <div class="display-1">
                    {{ statistique.totalFraisAll}}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
          <v-flex xs3 class="mb-2 mr-1">
          <v-card color="deep-orange  darken-3" class="white--text elevation-5">
            <v-container fluid grid-list-lg>
              <v-layout row style="text-align:center">
                <v-flex xs12>
                  <div>TOTAL DEMANDES CREES</div>
                  <div class="display-2">
                    {{ statistique.missAll }}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>

      <!--Listes des missions-->
      <v-card>
        <v-card-text fluid grid-list-md>
          <h2>LISTE DES DEMANDES DE MISSION</h2>
          <v-layout row v-if="droitAcces.list_mission">
            <v-flex class="mb-2">
              <el-select
                @change="filtrerMission"
                v-model="selectEtatMiss"
                placeholder="Filtrer la liste"
              >
                <el-option
                  v-for="item in comboEtatMiss"
                  :key="item.etat"
                  :label="item.label"
                  :value="item.etat"
                >
                </el-option>
              </el-select>
            </v-flex>
          </v-layout>
           <v-alert v-if="missionUser > 0" class="elevation-4 subheading mb-3" :value="true" color="warning" icon="priority_high" outline>
              Vous avez une demande de mission en attente de validation ou non cloturée. Vous devez patientez jusqu'à la validation de celle-ci ou vous devez cloturer la demande en cours avant de faire une autre demande
          </v-alert>
          <div class="text-xs-right">
            <v-tooltip top v-if="droitAcces.list_mission">
              <v-btn
                slot="activator"
                color="green"
                :disabled="disabledBtnMiss"
                @click.stop="imprimeMissionExc(selectEtatMiss)"
                dark
              >
                Liste en Excel
                <v-icon right> print</v-icon>
              </v-btn>
              Imprimer la liste des missions
            </v-tooltip>

            <v-tooltip top v-if="droitAcces.list_mission">
              <v-btn
                slot="activator"
                color="orange"
                :disabled="disabledBtnMiss"
                @click.stop="imprimeMission(selectEtatMiss)"
                dark
              >
                Liste
                <v-icon right> print</v-icon>
              </v-btn>
              Imprimer la liste des missions
            </v-tooltip>
            <!--Bouton ajouter Mission-->
            <v-tooltip top >
              <v-btn
              :disabled="missionUser > 0"
                slot="activator"
                color="primary"
                @click.stop="newDemande('formDemande')"
                dark
              >
                Mission
                <v-icon center>add</v-icon>
              </v-btn>
              Ajouter nouvelle demande de mission
            </v-tooltip>
          </div>
          <data-tables :data="tableMission">
            <el-table-column
              prop="ref"
              label="Réference"
              width="100"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="demandeur"
              label="Demandeur"
              width="200"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="activite"
              label="Activite"
              width="240"
            ></el-table-column>
            <el-table-column prop="budget" label="Budget (Fcfa)" width="120">
            </el-table-column>
            <el-table-column prop="depart" label="Départ" width="100">
            </el-table-column>
            <el-table-column prop="fin" label="Fin" width="100">
            </el-table-column>
            <el-table-column prop="retour" label="Retour prevu" width="180">
            </el-table-column>
            <el-table-column width="100" prop="etatFact" label="facture">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.etatFact == true" type="success"
                  >solde</el-tag
                >
                <el-tag v-if="scope.row.etatFact == false" type="danger"
                  >non-solde</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              width="260"
              align="center"
              prop="libEtat"
              label="Etat de la mission"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.etat == 3" type="info">{{
                  scope.row.libEtat
                }}</el-tag>
                <el-tag v-if="scope.row.etat == 5" type="warning">
                  {{ scope.row.libEtat }}</el-tag
                >
                <el-tag v-if="scope.row.etat == 1" type="success">{{
                  scope.row.libEtat
                }}</el-tag>
                <el-tag v-if="scope.row.etat == 2">{{
                  scope.row.libEtat
                }}</el-tag>
                <el-tag v-if="scope.row.etat == 4" type="danger">{{
                  scope.row.libEtat
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="Action"
              align="center"
              fixed="right"
              width="180"
            >
              <template slot-scope="scope">
                <v-tooltip top>
                  <v-btn
                    v-if="scope.row.etat == 3 && droitAcces.valider_mission"
                    slot="activator"
                    @click="showDetailMission(scope.row)"
                    fab
                    dark
                    small
                    color="green"
                  >
                    <v-icon dark>folder_open</v-icon>
                  </v-btn>
                  Détails
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    v-if="scope.row.etat == 1 && droitAcces.cloturer_mission"
                    slot="activator"
                    fab
                    small
                    icons
                    color="green"
                    @click.native="cloturerMission(scope.row)"
                    dark
                  >
                    <v-icon center>drive_eta</v-icon>
                  </v-btn>
                  Clôre la mission
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    v-if="scope.row.etat == 3"
                    slot="activator"
                    @click="editMission(scope.row)"
                    fab
                    dark
                    small
                    color="primary"
                  >
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  Modifier
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    v-if="scope.row.etat == 3"
                    slot="activator"
                    @click.stop="
                      dialogSupr = true;
                      MissId = scope.row.IdUtil;
                    "
                    fab
                    dark
                    small
                    color="red"
                  >
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                  Supprimer
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    v-if="scope.row.etat != 3 && droitAcces.valider_mission"
                    slot="activator"
                    fab
                    small
                    icons
                    color="warning"
                    @click.native="showValidMission(scope.row)"
                    dark
                  >
                    <v-icon center>description</v-icon>
                  </v-btn>
                  Fiche de Validation
                </v-tooltip>

                <v-tooltip
                  top
                  v-if="scope.row.etat === 1 || scope.row.etat === 2"
                >
                  <v-btn
                    slot="activator"
                    fab
                    small
                    icons
                    color="info"
                    @click="ImprimeSimpleMission(scope.row.IdUtil, 'simple')"
                    dark
                  >
                    <v-icon center>print</v-icon>
                  </v-btn>
                  Simple
                </v-tooltip>

                <v-tooltip
                  top
                  v-if="scope.row.etat === 1 || scope.row.etat === 2"
                >
                  <v-btn
                    slot="activator"
                    fab
                    small
                    icons
                    color="indigo"
                    @click="ImprimeSimpleMission(scope.row.IdUtil, 'details')"
                    dark
                  >
                    <v-icon center>print</v-icon>
                  </v-btn>
                  Détailé
                </v-tooltip>
              </template>
            </el-table-column>
          </data-tables>
        </v-card-text>
      </v-card>

      <!--DIALOG FORMULAIRE DEMANDE-->
      <v-dialog
        v-model="dialogDemande"
        transition="dialog-bottom-transition"
        scrollable
        :loading="loading"
        max-width="80%"
        persistent
      >
        <v-card>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>Ajouter une demande de mission</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="dialogDemande = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container fluid grid-list-md>
              <v-stepper v-model="d1">
                <v-stepper-header>
                  <v-stepper-step :complete="d1 > 1" step="1"
                    >Informations generales</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step :complete="d1 > 2" step="2"
                    >Participants</v-stepper-step
                  >
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-card>
                      <el-form
                        label-position="top"
                        :inline="true"
                        :model="formDemande"
                        :rules="rules"
                        ref="formDemande"
                        class="demo-form-inline"
                      >
                        <v-layout row>
                          <v-flex md4>
                            <el-form-item
                              label="Motif"
                              required
                              style="width:100%"
                            >
                              <el-input
                                v-model="formDemande.Activite"
                                placeholder="Motif"
                                style="width:100%"
                              ></el-input>
                            </el-form-item>
                          </v-flex>

                          <v-flex xs4 class="mr-1">
                            <el-form-item
                              label="Nom du demandeur"
                              prop="personne"
                            >
                              <el-autocomplete
                                v-model="formDemande.UserMission"
                                name="personne"
                                placeholder="nom du demandeur"
                                style="width: 100%"
                                :fetch-suggestions="loadDemandeur"
                              ></el-autocomplete>
                            </el-form-item>
                          </v-flex>

                          <v-flex xs4 class="mr-1">
                            <el-form-item
                              required
                              label="Contact du demandeur"
                              prop="tel1"
                            >
                              <el-input
                                v-model="formDemande.tel1"
                                name="tel1"
                                placeholder="Contact 1 du demandeur"
                                style="width: 100%"
                              ></el-input>
                            </el-form-item>
                          </v-flex>

                          <v-flex md4>
                            <el-form-item
                              label="Itineraire"
                              required
                              style="width:100%"
                            >
                              <el-input
                                v-model="formDemande.Itineraire"
                                placeholder="Itineraire"
                                style="width:100%"
                              ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md4>
                            <el-form-item
                              label="Chantier concerné"
                              style="width:100%"
                            >
                              <el-select
                                filterable
                                clearable
                                v-model="formDemande.Chantier"
                                placeholder="Select un chantier"
                                style="width:100%"
                              >
                                <el-option
                                  v-for="item in comboChantier"
                                  :key="item.id"
                                  :label="item.text"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex md4>
                            <el-form-item
                              label="Date de départ"
                              required
                              style="width:100%"
                            >
                              <el-date-picker
                                v-model="formDemande.DateSorti"
                                format="dd-MM-yyyy"
                                type="date"
                                id="Depart"
                                placeholder="Depart"
                                style="width:100%"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </v-flex>
                          <v-flex md4>
                            <el-form-item
                              label="Date de retour prévue"
                              style="width:100%"
                              required
                            >
                              <el-date-picker
                                v-model="formDemande.DateEntrePrevue"
                                format="dd-MM-yyyy"
                                type="date"
                                id="Retour"
                                placeholder="Retour"
                                style="width:100%"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </v-flex>
                          <v-flex md4>
                            <el-form-item
                              label="Description"
                              style="width:100%"
                            >
                              <el-input
                                type="textarea"
                                :rows="4"
                                id="Description"
                                placeholder="Description de la mission"
                                v-model="listDescription"
                                style="width:100%"
                              >
                              </el-input>
                            </el-form-item>
                          </v-flex>
                        </v-layout>
                      </el-form>

                      <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn flat color="error" @click="dialogDemande = false"
                          >Fermer<v-icon right>close</v-icon></v-btn
                        >

                        <v-btn
                          color="primary"
                          :disabled="!verifFormDmd()"
                          @click.native="d1 = 2"
                          >Continuer<v-icon right
                            >keyboard_arrow_right</v-icon
                          ></v-btn
                        >
                      </v-layout>
                    </v-card>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <v-card>
                      <v-flex xs12 class="mb-2">
                        <v-alert
                          :value="true"
                          outline
                          color="primary"
                          icon="info"
                        >
                          Vous pouvez ajouter des participants a la mission
                        </v-alert>
                      </v-flex>

                      <el-form
                        label-position="top"
                        :inline="true"
                        :model="formDemandePart"
                        class="demo-form-inline"
                      >
                        <v-layout row>
                          <v-flex md4>
                            <el-form-item
                              label="Nom"
                              required
                              style="width:100%"
                            >
                              <el-input
                                v-model="formDemandePart.Nom"
                                placeholder="Nom"
                                style="width:100%"
                              ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md4>
                            <el-form-item label="Prénom" style="width:100%">
                              <el-input
                                v-model="formDemandePart.Prenom"
                                placeholder="Prenom"
                                style="width:100%"
                              ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md4>
                            <el-form-item label="Fonction" style="width:100%">
                              <el-input
                                v-model="formDemandePart.Fonction"
                                placeholder="Fonction"
                                style="width:100%"
                              ></el-input>
                            </el-form-item>
                          </v-flex>
                        </v-layout>

                        <el-button
                          type="primary"
                          @click="addListParticipantDemande(formDemandePart)"
                          >Ajouter</el-button
                        >
                      </el-form>
                      <br />

                      <v-layout row>
                        <el-table
                          :data="tableParticipantDemande"
                          style="width: 100%"
                        >
                          <el-table-column prop="nom" label="Nom" sortable>
                          </el-table-column>
                          <el-table-column prop="prenom" label="Prénom">
                          </el-table-column>
                          <el-table-column
                            prop="fonction"
                            label="Fonction"
                          ></el-table-column>
                          <el-table-column label="Operations">
                            <template slot-scope="scope">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  fab
                                  small
                                  icons
                                  color="red"
                                  @click.native.prevent="
                                    deleteRow(
                                      scope.$index,
                                      tableParticipantDemande
                                    )
                                  "
                                  dark
                                >
                                  <v-icon center>delete</v-icon>
                                </v-btn>
                                Supprimer ce participant
                              </v-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </v-layout>
                      <br />
                    </v-card>

                    <v-layout row>
                      <v-spacer></v-spacer>
                      <v-btn
                        icons
                        flat
                        color="error"
                        @click="dialogDemande = false"
                        >Annuler <v-icon right>close</v-icon></v-btn
                      >
                      <v-btn color="primary" @click.native="d1 = 1"
                        ><v-icon>keyboard_arrow_left</v-icon>Précédent</v-btn
                      >
                      <v-btn
                        color="primary"
                        dark
                        @click="createDemande('formDemande')"
                        >Enregistrer<v-icon right>save</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--FIN DIALOG FORMULAIRE DEMANDE-->

      <!--  MODAL DETAIL MISSION ET VALIDATION-->
      <v-dialog
        v-model="dialogDetailMission"
        transition="dialog-bottom-transition"
        scrollable
        :loading="loading"
        fullscreen
        hide-overlay
      >
        <v-card tile>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>Fiche de mission</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="dialogDetailMission = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1"
                  >Informations generales</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2"
                  >Participants</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3"
                  >Budget de la mission</v-stepper-step
                >
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card color="" class="mb-5" flat>
                    <v-layout row>
                      <v-flex xs12>
                        <v-card flat>
                          <v-layout wrap>
                            <v-card-text>
                              <v-flex xs12>
                                <v-flex xs12 class="text-xs-left">
                                  <!--HAUT-->

                                  <v-layout row>
                                    <v-flex xs6 class="mr-4">
                                      <!--COLONNE 1-->

                                      <v-layout row>
                                        <v-flex xs6>Date Depart</v-flex>
                                        <v-flex xs6 class="text-xs-right title">
                                          {{ detailMission.debut }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout row>
                                        <v-flex xs6>Activite</v-flex>
                                        <v-flex xs6 class="text-xs-right title">
                                          {{ detailMission.activite }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout row>
                                        <v-flex xs6>Date de la demande</v-flex>
                                        <v-flex xs6 class="text-xs-right title">
                                          {{ detailMission.date }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout row>
                                        <v-flex xs6>Retour prevue</v-flex>
                                        <v-flex xs6 class="text-xs-right title">
                                          {{ detailMission.dateEntrePrevue }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout row>
                                        <v-flex xs6>Itineraire</v-flex>
                                        <v-flex xs6 class="text-xs-right title">
                                          {{ detailMission.itineraire }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>
                                    </v-flex>

                                    <v-flex xs6>
                                      <!--COLONNE 2-->
                                      <v-layout row>
                                        <v-flex xs6>chantier</v-flex>
                                        <v-flex
                                          xs6
                                          class="text-xs-right blue--text title"
                                        >
                                          {{ detailMission.chantier }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout row>
                                        <v-flex xs6>Demandeur </v-flex>
                                        <v-flex xs6 class="text-xs-right title">
                                          {{ detailMission.demandeur }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout row>
                                        <v-flex xs6>Etat</v-flex>
                                        <v-flex
                                          xs10
                                          class="text-xs-right blue--text  title"
                                        >
                                          {{ detailMission.libEtat }}
                                        </v-flex>
                                      </v-layout>
                                      <v-divider class="mb-3"></v-divider>

                                      <v-layout wrap>
                                        <v-flex xs6>Description</v-flex>
                                        <v-flex
                                          xs12
                                          class="text-xs-right title"
                                        >
                                        <el-input type="textarea" :row="4"
                                          :readonly="true"
                                          :value="detailMission.description"
                                           style="width: 100%">
                                        </el-input>
                                          <!-- <v-text-field
                                            disabled
                                            :rows="4"
                                            :value="detailMission.description"
                                            label=""
                                            placeholder=""
                                            outline
                                          ></v-text-field> -->
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                            </v-card-text>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click.native="e1 = 1"
                        >Precedent</v-btn
                      >
                      <v-btn color="primary" @click.native="e1 = 2"
                        >Suivant</v-btn
                      >
                    </v-layout>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-card color="" class="mb-5">
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs12 class="mb-3 mt-3">
                          <v-alert
                            :value="true"
                            outline
                            color="purple"
                            icon="info"
                          >
                            Vous pouvez ajouter ou modifier des participants a
                            la mission
                          </v-alert>
                        </v-flex>

                        <!--Formulaire Ajout participant-->
                        <v-flex xs12>
                          <el-form
                            :inline="true"
                            :model="formParticipant"
                            class="demo-form-inline"
                          >
                            <el-form-item>
                              <el-input
                                v-model="formParticipant.Nom"
                                placeholder="Nom"
                              ></el-input>
                            </el-form-item>

                            <el-form-item>
                              <el-input
                                v-model="formParticipant.Prenom"
                                placeholder="Prenom"
                              ></el-input>
                            </el-form-item>

                            <el-form-item>
                              <el-input
                                v-model="formParticipant.Fonction"
                                placeholder="Fonction"
                              ></el-input>
                            </el-form-item>

                            <el-form-item>
                              <el-button
                                v-if="
                                  detailMission.etat == 3 ||
                                    detailMission.etat == 5
                                "
                                type="primary"
                                @click="addListParticipant(formParticipant)"
                                >Ajouter</el-button
                              >
                            </el-form-item>
                          </el-form>
                        </v-flex>

                        <v-flex xs12>
                          <el-table
                            :data="tableParticipant"
                            style="width: 100%"
                          >
                            <el-table-column prop="nom" label="Nom" sortable>
                            </el-table-column>
                            <el-table-column prop="prenom" label="Prenom">
                            </el-table-column>
                            <el-table-column prop="fonction" label="Fonction">
                            </el-table-column>

                            <el-table-column label="Operations">
                              <template slot-scope="scope">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    fab
                                    small
                                    icons
                                    color="red"
                                    @click.native.prevent="
                                      deleteRow(scope.$index, tableParticipant)
                                    "
                                    dark
                                  >
                                    <v-icon center>delete</v-icon>
                                  </v-btn>
                                  Supprimer ce participant
                                </v-tooltip>
                              </template>
                            </el-table-column>
                          </el-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-layout row>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native="e1 = 1"
                      >Precedent</v-btn
                    >
                    <v-btn color="primary" @click.native="e1 = 3"
                      >Suivant</v-btn
                    >
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-card color="" class="mb-5">
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-alert
                            :value="true"
                            outline
                            color="purple"
                            icon="info"
                          >
                            Etablissez le budget de la mission
                          </v-alert>
                        </v-flex>

                        <!--Formulaire Frais de mission-->
                        <v-flex xs12>
                          <el-form :inline="true" class="demo-form-inline">
                            <!--<el-form-item>-->
                            <!--<el-checkbox v-model="remboursable">Frais remboursable</el-checkbox>-->
                            <!--</el-form-item>-->

                            <el-form-item>
                              <el-radio
                                v-model="radioVeh"
                                label="Vehicule personnel"
                                >Vehicule personnel</el-radio
                              >
                            </el-form-item>

                            <el-form-item>
                              <el-radio
                                v-model="radioVeh"
                                label="Transport en commun"
                                >Transport en commun</el-radio
                              >
                            </el-form-item>

                            <el-form-item>
                              <el-radio
                                v-model="radioVeh"
                                label="Vehicule de service"
                                >Vehicule de service</el-radio
                              >
                            </el-form-item>

                            <el-form-item>
                              <el-select
                                v-model="vehSelect"
                                @change="selectVehicule(vehSelect)"
                                :disabled="radioVeh != 'Vehicule de service'"
                                placeholder="Select un vehicule"
                              >
                                <el-option
                                  v-for="item in comboVeh"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>

                            <el-form-item>
                              <el-select
                                v-model="condSelect"
                                :disabled="radioVeh != 'Vehicule de service'"
                                placeholder="Conducteur affecté au vehicule "
                              >
                                <el-option
                                  v-for="item in comboCond"
                                  :key="item.id"
                                  :label="item.text"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>

                            <el-form-item label="">
                              <el-date-picker
                                v-model="dateLimit"
                                type="date"
                                value-format="yyyy-MM-dd"
                                id="DatePaiement"
                                placeholder="Date limite de paiement"
                              >
                              </el-date-picker>
                            </el-form-item>

                            <el-form-item>
                              <el-select
                                v-model="caisseSelect"
                                placeholder="Selectionner une caisse"
                              >
                                <el-option
                                  v-for="item in listeCaisse"
                                  :key="item.id"
                                  :label="item.libelle"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-form>
                        </v-flex>
                        <v-flex xs12>
                          <el-form
                            :inline="true"
                            :model="formFrais"
                            class="demo-form-inline"
                            label-position="top"
                          >
                            <el-form-item label="Libelle">
                              <el-input
                                v-model="formFrais.libelle"
                                placeholder="libelle"
                              ></el-input>
                            </el-form-item>

                            <el-form-item label="Quantite">
                              <el-input-number
                                :min="1"
                                size="large"
                                @change="calculTotalComm()"
                                controls-position="right"
                                v-model="formFrais.quantite"
                                placeholder="quantite"
                              ></el-input-number>
                            </el-form-item>

                            <el-form-item label="Prix Unitaire(FCFA)">
                              <el-input-number
                                :min="0"
                                size="large"
                                @change="calculTotalComm()"
                                controls-position="right"
                                v-model="formFrais.prixUnit"
                                placeholder="prix unitaire(HT)"
                              ></el-input-number>
                            </el-form-item>
                            <el-form-item label="Tva">
                              <el-input-number
                                :value="0"
                                :min="0"
                                size="large"
                                @change="calculTotalComm()"
                                controls-position="right"
                                v-model="formFrais.tva"
                                placeholder="tva(%)"
                              ></el-input-number>
                            </el-form-item>

                            <el-form-item label="Total">
                            <el-input type="number" @change="calculTotalComm()" :min="0" value="total" :prop="totalLigne" placeholder="TOTAL" v-model="totalLigne" style="width:50%" :readonly="true">
                            </el-input>
                                <el-button
                                :disabled="!verifBudget"
                                v-if="
                                  detailMission.etat == 3 ||
                                    detailMission.etat == 5
                                "
                                type="primary"
                                @click="addListFrais(formFrais)"
                                >Ajouter</el-button
                              >
                            </el-form-item>
                          </el-form>
                          <v-spacer></v-spacer>
                          <v-chip
                            style="font-size:20px"
                            label
                            outline
                            color="green"
                            ><b
                              >Total (HT):
                              {{
                                new Intl.NumberFormat().format(totalHT)
                              }}
                              fcfa</b
                            ></v-chip
                          >
                          <v-chip
                            style="font-size:20px"
                            label
                            outline
                            color="green"
                            ><b
                              >Total (TVA):
                              {{
                                new Intl.NumberFormat().format(totalTVA)
                              }}
                              fcfa</b
                            ></v-chip
                          >
                          <v-chip
                            style="font-size:20px"
                            label
                            outline
                            color="green"
                            ><b
                              >Total (TTC):
                              {{
                                new Intl.NumberFormat().format(totalTTC)
                              }}
                              fcfa</b
                            ></v-chip
                          >
                        </v-flex>

                        <v-flex xs12>
                          <el-table :data="tableFrais" style="width: 100%">
                            <el-table-column
                              prop="libelle"
                              label="Libelle"
                              sortable
                            >
                            </el-table-column>
                            <el-table-column prop="quantite" label="Quantite">
                            </el-table-column>

                            <el-table-column
                              prop=""
                              label="Prix unitaire(FCFA)"
                            >
                              <template slot-scope="scope">
                                {{
                                  new Intl.NumberFormat().format(
                                    scope.row.prixUnit
                                  )
                                }}
                              </template>
                            </el-table-column>

                            <el-table-column prop="tva" label="TVA(%)">
                            </el-table-column>

                            <el-table-column prop="total" label="Total(FCFA)">
                              <template slot-scope="scope">
                                {{
                                  new Intl.NumberFormat().format(
                                    scope.row.total
                                  )
                                }}
                              </template>
                            </el-table-column>

                            <el-table-column label="Operations">
                              <template slot-scope="scope">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    fab
                                    small
                                    icons
                                    color="red"
                                    @click.native.prevent="
                                      deleteRowBudget(scope.$index, tableFrais)
                                    "
                                    dark
                                  >
                                    <v-icon center>delete</v-icon>
                                  </v-btn>
                                  Supprimer
                                </v-tooltip>
                              </template>
                            </el-table-column>
                          </el-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native="e1 = 2"
                    >Precedent</v-btn
                  >

                  <v-btn
                    dark
                    v-if="detailMission.etat == 3 || detailMission.etat == 5"
                    color="red"
                    @click.native="dialogRejeterMission = true"
                    >Rejeter</v-btn
                  >
                  <v-btn
                    dark
                    v-if="detailMission.etat == 3 || detailMission.etat == 5"
                    color="green"
                    @click.native="showDialogAccord()"
                    >Valider</v-btn
                  >
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <!-- FIN MODAL DETAIL MISSION ET VALIDATION-->

      <!--  MODAL VALIDATION MISSION-->
      <v-dialog
        v-model="dialogValidMission"
        transition="dialog-bottom-transition"
        scrollable
        :loading="loading"
        fullscreen
        hide-overlay
      >
        <v-card>
          <v-toolbar card dark color="primary">
            <v-toolbar-title
              >Fiche de validation de la mission
              {{ detailMission.IdUtil }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="dialogValidMission = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout>
              <v-flex>
                <v-card color="" class="mb-5" flat>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-alert :value="true" outline color="purple" icon="info">
                        Informations generales
                      </v-alert>

                      <v-card flat>
                        <v-layout wrap>
                          <v-card-text>
                            <v-flex xs12>
                              <v-flex xs12 class="text-xs-left">
                                <!--HAUT-->
                                <v-layout row>
                                  <v-flex xs6 class="mr-4">
                                    <!--COLONNE 1-->
                                    <v-layout row>
                                      <v-flex xs6>Date Depart</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.debut }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Activite</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.activite }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Caisse</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.caisse }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Date de la demande</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.date }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Retour prevue</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.dateEntrePrevue }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Itineraire</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.itineraire }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Marque</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.marque }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Modele</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.modele }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Serie</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.serie }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Moyen de transport</v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.modeTransport }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
                                  </v-flex>

                                  <v-flex xs6>
                                    <!--COLONNE 2-->
                                    <v-layout row>
                                      <v-flex xs6>chantier</v-flex>
                                      <v-flex
                                        xs6
                                        class="text-xs-right blue--text title"
                                      >
                                        {{ detailMission.chantier }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Demandeur </v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.demandeur }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Conducteur </v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.nomPren }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Validateur 1 </v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.validateur1 }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Validateur 2 </v-flex>
                                      <v-flex xs6 class="text-xs-right title">
                                        {{ detailMission.validateur2 }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout row>
                                      <v-flex xs6>Etat</v-flex>
                                      <v-flex
                                        xs10
                                        class="text-xs-right blue--text  title"
                                      >
                                        {{ detailMission.libEtat }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>

                                    <v-layout wrap>
                                      <v-flex xs6>Description</v-flex>
                                      <v-flex xs10>
                                        <el-form class="demo-ruleForm">
                                          <el-form-item
                                            label=""
                                            style="width:100%"
                                          >
                                            <el-input
                                              :readonly="true"
                                              type="textarea"
                                              :rows="6"
                                              v-model="
                                                detailMission.description
                                              "
                                            ></el-input>
                                          </el-form-item>
                                        </el-form>
                                      </v-flex>

                                      <!-- <v-flex xs12 class="text-xs-right title">
                                                                                <v-text-field
                                                                                        disabled
                                                                                        :value="detailMission.description"
                                                                                        label=""
                                                                                        multiLine
                                                                                        placeholder=""
                                                                                        outline
                                                                                ></v-text-field>
                                                                            </v-flex> -->
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>
                          </v-card-text>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex xs12>
                      <v-alert :value="true" outline color="purple" icon="info">
                        Informations participants
                      </v-alert>
                      <v-card color="" class="mb-5">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs12>
                              <el-table
                                :data="tableParticipant"
                                style="width: 100%"
                              >
                                <el-table-column
                                  prop="nom"
                                  label="Nom"
                                  sortable
                                >
                                </el-table-column>
                                <el-table-column prop="prenom" label="Prenom">
                                </el-table-column>
                                <el-table-column
                                  prop="fonction"
                                  label="Fonction"
                                >
                                </el-table-column>
                              </el-table>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex xs12>
                      <v-alert :value="true" outline color="purple" icon="info">
                        Informations frais de mission
                      </v-alert>
                      <v-card color="" class="mb-5">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs6 class="mr-1">
                              <v-layout row>
                                <v-flex xs6>Enregistré par</v-flex>
                                <v-flex xs6 class="text-xs-right title">
                                  {{ detailMission.validateur1 }}
                                </v-flex>
                              </v-layout>
                              <v-divider class="mb-3"></v-divider>
                            </v-flex>
                            <v-flex xs6>
                              <v-layout row>
                                <v-flex xs6>date d'enregistrement</v-flex>
                                <v-flex xs6 class="text-xs-right title">
                                  {{ detailMission.dateValidation1 }}
                                </v-flex>
                              </v-layout>
                              <v-divider class="mb-3"></v-divider>
                            </v-flex>
                          </v-layout>

                          <v-layout wrap>
                            <v-flex xs12>
                              <v-chip
                                style="font-size:20px"
                                label
                                outline
                                color="green"
                                ><b
                                  >Total (HT):
                                  {{
                                    new Intl.NumberFormat().format(
                                      detailMission.totalFraisHT
                                    )
                                  }}
                                  fcfa</b
                                ></v-chip
                              >
                              <v-chip
                                style="font-size:20px"
                                label
                                outline
                                color="green"
                                ><b
                                  >Total (TVA):
                                  {{
                                    new Intl.NumberFormat().format(
                                      detailMission.totalTva
                                    )
                                  }}
                                  fcfa</b
                                ></v-chip
                              >
                              <v-chip
                                style="font-size:20px"
                                label
                                outline
                                color="green"
                                ><b
                                  >Total (TTC):
                                  {{
                                    new Intl.NumberFormat().format(
                                      detailMission.totalFrais
                                    )
                                  }}
                                  fcfa</b
                                ></v-chip
                              >
                            </v-flex>

                            <v-flex xs12>
                              <el-table :data="tableFrais" style="width: 100%">
                                <el-table-column
                                  prop="libelle"
                                  label="Libelle"
                                  sortable
                                >
                                </el-table-column>
                                <el-table-column
                                  prop="quantite"
                                  label="Quantite"
                                >
                                </el-table-column>

                                <el-table-column
                                  prop="prixUnit"
                                  label="Prix unitaire"
                                >
                                  <template slot-scope="scope">
                                    {{
                                      new Intl.NumberFormat().format(
                                        scope.row.prixUnit
                                      )
                                    }}
                                  </template>
                                </el-table-column>

                                <el-table-column prop="tva" label="TVA">
                                  <template slot-scope="scope">
                                    {{
                                      new Intl.NumberFormat().format(
                                        scope.row.tva
                                      )
                                    }}
                                  </template>
                                </el-table-column>

                                <el-table-column prop="total" label="Total">
                                  <template slot-scope="scope">
                                    {{
                                      new Intl.NumberFormat().format(
                                        scope.row.total
                                      )
                                    }}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 v-if="detailMission.etat == 2">
                      <v-alert :value="true" outline color="purple" icon="info">
                        Rapport de mission
                      </v-alert>
                      <v-card color="" class="mb-5">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs6 class="mr-3">
                              <v-layout row>
                                <v-flex xs6>Enregistré par</v-flex>
                                <v-flex xs6 class="text-xs-right title">
                                  {{ detailMission.userRapport }}
                                </v-flex>
                              </v-layout>
                              <v-divider class="mb-3"></v-divider>
                              <v-layout row>
                                <v-flex xs6>Date Retour</v-flex>
                                <v-flex xs6 class="text-xs-right title">
                                  {{ detailMission.retour }}
                                </v-flex>
                              </v-layout>

                              <v-layout row v-show="detailMission.idVeh != ''">
                                <v-layout row>
                                  <v-flex xs6>Carburant consommé (L)</v-flex>
                                  <v-flex xs6 class="text-xs-right title">
                                    {{ detailMission.mntCarburant }}
                                  </v-flex>
                                </v-layout>
                                <v-divider class="mb-3"></v-divider>

                                <v-layout row>
                                  <v-flex xs6>Montant Carburant (Fcfa)</v-flex>
                                  <v-flex xs6 class="text-xs-right title">
                                    {{ detailMission.carbConsom }}
                                  </v-flex>
                                </v-layout>
                                <v-divider class="mb-3"></v-divider>

                                <v-layout row>
                                  <v-flex xs6>Compteur de kilometrage</v-flex>
                                  <v-flex xs6 class="text-xs-right title">
                                    {{ detailMission.kmRetour }}
                                  </v-flex>
                                </v-layout>
                              </v-layout>
                              <v-divider class="mb-3"></v-divider>

                              <v-layout row>
                                <v-flex xs3 class="mr-3">
                                  <a
                                    :href="detailMission.imageRapport"
                                    target="_blank"
                                  >
                                    <v-avatar
                                      :tile="true"
                                      size="140px"
                                      height="120px"
                                      color="grey lighten-4"
                                    >
                                      <img :src="detailMission.imageRapport"
                                    /></v-avatar>
                                  </a>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs5>
                              <v-layout wrap class="ml-4 ">
                                <v-flex xs12>Rapport de mission</v-flex>
                                <v-flex xs10>
                                  <el-form class="demo-ruleForm">
                                    <el-form-item label="" style="width:100%">
                                      <el-input
                                        :readonly="true"
                                        type="textarea"
                                        v-model="detailMission.rapport"
                                      ></el-input>
                                    </el-form-item>
                                  </el-form>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>
        </v-card>

        <v-tooltip top v-if="droitAcces.valider2_mission">
          <v-btn
            v-if="detailMission.etat == 5"
            class="mb-5"
            style="margin-right: 100px"
            absolute
            slot="activator"
            dark
            fab
            large
            bottom
            right
            color="red"
            @click="dialogRejeterMission = true"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <span>Refuser la mission</span>
        </v-tooltip>

        <v-tooltip top  v-if="droitAcces.valider2_mission">
          <v-btn
            v-if="detailMission.etat == 5"
            class="mb-5 ml-5"
            absolute
            slot="activator"
            dark
            fab
            large
            bottom
            right
            color="green"
            @click="confValMission()"
          >
            <v-icon>done</v-icon>
          </v-btn>
          <span>Valider la mission</span>
        </v-tooltip>
      </v-dialog>
      <!-- FIN MODAL VALIDATION MISSION-->

      <!--  MODAL CLOTURER MISSION -->
      <v-dialog
        v-model="dialogCloturerMission"
        transition="dialog-bottom-transition"
        scrollable
        :loading="loading"
        width="80%"
        persistent
      >
        <v-card tile>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>Cloturer une mission</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="dialogCloturerMission = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <el-form
              :model="formCloture"
              class="demo-form-inline"
              id="formRapport"
            >
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-form-item label="Date de retour *">
                      <el-date-picker
                        id="dateRetour"
                        v-model="formCloture.DateRetour"
                        type="date"
                        format="dd-MM-yyyy"
                        placeholder="Date de retour"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="6" v-show="detailMission.idVeh != ''"
                  ><div class="grid-content bg-purple">
                    <el-form-item label="Carburant consomme">
                      <el-input
                        v-model.number="formCloture.CarbConsom"
                        placeholder="Carburant consomme(L)"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="6" v-show="detailMission.idVeh != ''"
                  ><div class="grid-content bg-purple">
                    <el-form-item label="Montant carburant">
                      <el-input
                        v-model.number="formCloture.MontantCarburant"
                        placeholder="Montant carburant(FCFA)"
                      ></el-input>
                    </el-form-item></div
                ></el-col>

                <el-col :span="6" v-show="detailMission.idVeh != ''">
                  <div class="grid-content bg-purple">
                    <el-form-item label="Kilometrage retour">
                      <el-input
                        v-model.number="formCloture.KmRetour"
                        placeholder="Kilometrage retour"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="16">
                  <div class="grid-content bg-purple">
                    <el-form-item>
                      <el-input
                        type="textarea"
                        :rows="10"
                        placeholder="Saisir le rapport de mission"
                        v-model="formCloture.Rapport"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="8">
                  <div class="grid-content bg-purple-light">
                    <v-flex xs8 class="ml-4">
                      <v-avatar
                        :tile="true"
                        size="160px"
                        height="120px"
                        color="grey lighten-4"
                      >
                        <img :src="image1Rpt" alt="avatar"
                      /></v-avatar>
                      <div class="font-weight-thin">
                        Fichier au format (JPEG,PNG,PDF) avec une taille de 3Mo
                        ko maximale
                      </div>

                      <v-layout row>
                        <input
                          name="image1"
                          type="file"
                          style="display:none"
                          ref="file1Rpt"
                          accept="image/*"
                          @change="onFileImage1RptPicked"
                        />
                        <v-btn
                          color="primary"
                          class="white--text"
                          required
                          @click.native="$refs.file1Rpt.click()"
                          >Pièce jointe
                          <v-icon right dark>cloud_upload</v-icon></v-btn
                        >
                      </v-layout>
                    </v-flex>
                  </div>
                </el-col>
              </el-row>

              <v-flex xs12 class="mt-4">
                <el-row :gutter="20" style="margin-top:10px;">
                  <el-col :span="6" :offset="18">
                    <el-form-item>
                      <el-button
                        type="info"
                        @click="dialogCloturerMission = false"
                        >Fermer</el-button
                      >
                      <el-button type="success" @click="valideCloture()"
                        >Cloturer</el-button
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </v-flex>
            </el-form>
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <!-- FIN MODAL CLOTURER MISSION-->

      <!--  MODAL ACCORD VALIDATION MISSION -->
      <v-dialog v-model="dialogAccord" max-width="290">
        <v-card>
          <v-card-title class="headline"
            >Voulez-vous validez la mission ?</v-card-title
          >
          <v-card-text
            >En cliquant sur valider, en tant que responsable, vous donnez votre
            accord pour l'execution de cette mission</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="dialogAccord = false"
              >Annuler</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="validMission(detailMission.etat)"
              >Valider</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--  MODAL ACCORD VALIDATION MISSION -->

      <!--  MODAL ACCORD VALIDATION MISSION 2 -->
      <v-dialog v-model="dialogAccord2" max-width="290">
        <v-card>
          <v-card-title class="headline"
            >Voulez-vous validez la mission ?</v-card-title
          >
          <v-card-text
            >En cliquant sur valider, en tant que responsable, vous donnez votre
            accord pour l'execution de cette mission</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="dialogAccord2 = false"
              >Annuler</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="valid2Mission()"
              >Valider</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--  MODAL ACCORD VALIDATION MISSION 2-->

      <!-- MODAL CONFIRMATION REFUS-->
      <v-dialog
        v-model="dialogRejeterMission"
        width="40%"
        :overlay="true"
        scrollable
        persistent
      >
        <v-card>
          <v-card-title class="text-xs-center">
            <h3 class="headline mb-0">Rejeter la demande de mission</h3>
            <v-flex xs12>
              <v-alert
                outline
                color="orange darken-1"
                icon="warning"
                :value="true"
              >
                Etes-vous sur de vouloir rejeter l'ordre de mission ?
              </v-alert>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <el-form class="demo-form-inline">
              <el-row :gutter="20">
                <el-form-item label="Motif du refus">
                  <el-input
                    type="textarea"
                    placeholder="Motif du refus"
                    v-model="motifRejet"
                  >
                  </el-input>
                </el-form-item>
              </el-row>
            </el-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.stop="dialogRejeterMission = false">Annuler</v-btn>
            <v-btn icons color="red" @click.stop="rejetMission()" dark
              >Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FIN MODAL CONFIRMATION REFUS-->

      <!-- MODAL SUPPRESSION -->
      <v-dialog
        v-model="dialogSupr"
        max-width="50%"
        :overlay="true"
        scrollable
        persistent
      >
        <v-card>
          <v-card-text text-xs-center>
            <h6 align="center">
              Voulez-vous vraiment supprimer cette mission ?
            </h6>
            <p align="center">
              <v-btn @click.native="dialogSupr = false" color="orange" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="red" @click.stop="deleteMission" dark
                >Supprimer <v-icon right>delete</v-icon></v-btn
              >
            </p>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "Mission",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/mission/Mission", text: "Mission", disabled: false }
      ],
      dialogDemande: false,
      tableMission: [],
      statistique: [],
      tableParticipant: [],
      tableParticipantDemande: [],
      listDescription: [],
      tableFrais: [],
      dialogSuppParticipant: false,
      dialogCloturerMission: false,
      dialogEditMiss: false,
      formDemande: {},
      active: 1,
      detailMission: {},
      isEdit: false,
      idEditMission: "",
      MissId: "",
      dialogDetailMission: false,
      idMission: null,
      dialogValidMission: false,
      dialogSupr: false,
      e1: 1,
      d1: 1,
      idPartMod: null,
      formParticipant: {},
      formDemandePart: {},
      formFrais: {
        quantite: 1,
        prixUnit: 5,
        tva: 0
      },
      formCloture: {},
      remboursable: false,
      radioVeh: "Vehicule de service",
      vehSelect: null,
      comboVeh: [],
      listeCaisse: [],
      chantierSelect: null,
      comboChantier: [],
      totalLigne:0,
      comboCond: [],
      condSelect: "",
      comboUser: [],
      userMission: null,
      totalTTC: null,
      totalHT: null,
      totalTVA: null,
      total: null,
      dialogAccord: false,
      dialogAccord2: false,
      dialogValidMission: false,
      dialogRejeterMission: false,
      caisseSelect: null,
      motifRejet: "",
      dateLimit: "",
      nbMissFin: 0,
      nbMissRetour: 0,
      missionUser: 0,
      rules: {
        req: [
          {
            required: true,
            message: "Veuillez remplir ce champ",
            trigger: "blur"
          }
        ],
        tel1: [
          {
            required: true,
            message: "Veuillez remplir ce champ",
            trigger: "blur"
          }
        ]
      },
      selectEtatMiss: 0,
      disabledBtnMiss: false,
      comboEtatMiss: [
        {
          etat: 0,
          label: "Toutes les missions"
        },
        {
          etat: 1,
          label: "En cours"
        },
        {
          etat: 2,
          label: "Cloture"
        },
        {
          etat: 3,
          label: "En attente de la premiere validation"
        },

        {
          etat: 4,
          label: "Annule"
        },
        {
          etat: 5,
          label: "En attente de la deuxieme validation"
        }
      ],
      //image
      image1Rpt: "/static/img-doc.png",
      file1Rpt: "/static/img-doc.png"
    };
  },

  computed: {
    verifBudget: function() {
      if (
        this.formFrais.libelle == undefined ||
        this.formFrais.libelle == null ||
        this.formFrais.libelle == "" ||
        this.formFrais.quantite == 0 ||
        this.formFrais.prixUnit == 0 ||
        this.formFrais.tva == undefined
      ) {
        return false;
      }
      return true;
    }
  },

  methods: {
    filtrerMission(etat) {
      this.loadMissParEtat(etat);
    },
    calculTotalComm(){
      let quantite = this.formFrais.quantite
      let prixUnit = this.formFrais.prixUnit
      let tva = this.formFrais.tva
      let mnt = quantite * prixUnit;
      let mntTva = (mnt * tva) / 100;
      this.totalLigne = mnt + mntTva
    },
    loadMissParEtat(etat) {
      let url = this.domaine + "mission/etat_miss";
      var data = new FormData();
      data.append("etat", etat);
      this.loading = true;
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.tableMission = response.body.missions;
            if (
              this.tableMission === undefined ||
              this.tableMission.length == 0
            ) {
              this.disabledBtnMiss = true;
            } else {
              this.disabledBtnMiss = false;
            }
          }
        },
        response => {
          this.loading = false;
          this.$message.error("Erreur sur le  filtre des de missions");
        }
      );
    },
    loadMissParEtatByUser(etat) {
      let url = this.domaine + "mission/etat_miss/user";
      var data = new FormData();
      data.append("userid", this.user.id);
      data.append("etat", etat);
      this.loading = true;
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.tableMission = response.body.missions;
            if (
              this.tableMission === undefined ||
              this.tableMission.length == 0
            ) {
              this.disabledBtnMiss = true;
            } else {
              this.disabledBtnMiss = false;
            }
          }
        },
        response => {
          this.loading = false;
          this.$message.error("Erreur sur le  filtre des de missions");
        }
      );
    },
    rejetMission() {
      this.loading = true;
      let url = this.domaine + "mission/rejeter";
      var data = new FormData();
      data.append("motifRefus", this.motifRejet);
      data.append("idMission", this.detailMission.IdUtil);
      data.append("user", this.user.id);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "REFUSER DEMANDE MISSION",
            message: resp.body.message,
            type: "success",
            position: "top-right"
          });
          this.dialogRejeterMission = false;
          this.dialogDetailMission = false;
          this.dialogValidMission = false;
          this.loadMissions();
        },
        respError => {
          this.loading = false;
          this.$message.error("Erreur lors du rejet de l'ordre de mission");
        }
      );
    },
    cloturerMission(item) {
      this.idMission = item.IdUtil;
      this.dialogCloturerMission = true;
    },
    selectVehicule(item){
      this.loadConducteurDisp(item)
    },
    loadConducteurDisp(item) {
      this.loading = true;
      let url = this.domaine + "conducteur/disponible/"+item;
      this.$http.get(url).then(
        resp => {
          this.loading = false;
          this.comboCond = resp.body.conducteur;
        },
        respError => {
          this.loading = false;
          this.$message.error(
            "Erreur lors du chargement des informations du conducteur"
          );
        }
      );
    },
    valideCloture() {
      if(this.formCloture.DateRetour ==''){
        return  this.$message.error(
          "Veuillez renseigner les champs obligatoires"
        );
      }
      this.loading = true;
      let url = this.domaine + "mission/cloturer";
      let form = document.getElementById("formRapport");
      let data = new FormData(form);
      data.append("idMission", this.idMission);
      data.append("user", this.user.id);
      data.append("formCloture", JSON.stringify(this.formCloture));
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.image1Rpt = "/static/img-doc.png";

          if(resp.body.code == 5) {
            this.$notify({
            title: "CLOTURER MISSION",
            message: resp.body.message,
            type: "warning",
            position: "top-right"
          });
          }else{
           this.$notify({
            title: "CLOTURER MISSION",
            message: resp.body.message,
            type: "success",
            position: "top-right"
          });
          }
          this.dialogCloturerMission = false;
          this.loadMissions();
        },
        resp => {
          this.$message.error("Erreur lors de la cloture  de la mission");
          this.loading = false;
        }
      );
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    deleteRowBudget(index, rows) {
      let item = rows.splice(index, 1);
      let mnt = item[0].quantite * item[0].prixUnit;
      let mntTva = (mnt * item[0].tva) / 100;
      let mntTx = mnt + mntTva;
      this.totalTTC -= mntTx;
      this.totalHT -= mnt;
      this.totalTVA -= mntTva;
    },
    closeDialog() {
      this.$emit("close");
    },
    confValidMission() {
      this.dialogValidMission = true;
    },
    loadMissions() {
      let url = "";
      if (this.droitAcces.list_mission) {
        url = this.domaine + "mission/index";
      } else if (this.droitAcces.list_mission_personne) {
        //pour une personne qui a fait la demande
        url = this.domaine + "mission/index/personne/" + this.user.id;
      } else if (this.droitAcces.list_mission_user) {
        //affiche les elements de celui qui est connecté
        url = this.domaine + "mission/index/" + this.user.id;
      }
      this.$http.get(url).then(
        resp => {
          this.tableMission = resp.body.missions;
          this.statistique = resp.body.stat;
          this.nbUtil = resp.body.nbUtil;
          this.nbMissFin = resp.body.nbMissFin;
          this.nbMissRetour = resp.body.nbMissRetour;
          this.missionUser = resp.body.missionUser

          if (this.notif === "active" && this.droitAcces.valider2_mission && this.statistique.missAvalide2 > 0 ) {
              this.$vs.notify({
                title: "DEMANNDE DE MISSION",
                text:
                  "Vous avez des demandes de mission à valider",
                color: "danger",
                position: "top-right",
                icon: "description",
                fixed: false,
                time: 10000,
              });
            }

           if (this.notif === "active" && !this.droitAcces.valider2_mission && this.statistique.missAvalide1 > 0 ) {
              this.$vs.notify({
                title: "DEMANNDE DE MISSION",
                text:
                  "Vous avez des demandes de mission à approuver",
                color: "danger",
                position: "top-right",
                icon: "description",
                fixed: false,
                time: 10000,
              });
            }
        },
        resp => {
          this.$message.error("erreur lors du chargement des missions.");
        }
      );
    },
    removeParticipant(item) {
      var index = this.formDemande.participants.indexOf(item);
      if (index !== -1) {
        this.formDemande.participants.splice(index, 1);
      }
    },
    addParticipant() {
      this.formDemande.participants.push({
        key: Date.now(),
        Nom: "",
        Prenom: "",
        Fonction: "",
        Contact: ""
      });
    },
    ImprimeSimpleMission(idMiss, format) {
      let url =
        this.domaine +
        "mission/impression/" +
        idMiss +
        "/" +
        format +
        "/" +
        this.user.id;
      let data = {
        idUser: this.user.id
      };
      this.$http.get(url, { params: data }).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    addListParticipant(item) {
      if (
        item.Nom == undefined &&
        item.Prenom == undefined &&
        item.Fonction == undefined
      ) {
        this.$message.error("Veuillez remplir correctement les champs");
        return;
      }
      this.tableParticipant.push({
        nom: item.Nom,
        prenom: item.Prenom,
        fonction: item.Fonction,
        contact: item.Contact
      });

      this.formParticipant = {};
    },
    addListParticipantDemande(item) {
      if (
        item.Nom == undefined ||
        item.Prenom == undefined ||
        item.Fonction == undefined
      ) {
        this.$message.error("Veuillez remplir correctement les champs");
        return;
      }
      this.tableParticipantDemande.push({
        nom: item.Nom,
        prenom: item.Prenom,
        fonction: item.Fonction
      });

      this.formDemandePart = {};
    },
    addListFrais(item) {
      this.tableFrais.push({
        libelle: item.libelle,
        quantite: item.quantite,
        prixUnit: item.prixUnit,
        tva: item.tva ? item.tva : 0,
        total:
          item.quantite * item.prixUnit +
          (item.quantite * item.prixUnit * item.tva) / 100
      });
      this.formFrais = {
        libelle: null,
        quantite: 1,
        prixUnit: 5,
        tva: 0
      };
      let mnt = item.quantite * item.prixUnit;
      this.totalHT += mnt;
      let mntTva = (mnt * item.tva) / 100;
      this.totalTVA += mntTva;
      let mntTx = mnt + mntTva;
      this.totalTTC += mntTx;
      this.totalLigne = 0
    },
    validMission(etatValMiss) {
      this.loading = true;
      let url = this.domaine + "mission/valide/demande";
      let data = new FormData();
      data.append("idMission", this.idMission);
      data.append("etatValMiss", etatValMiss);
      data.append("tabParticipant", JSON.stringify(this.tableParticipant));
      data.append("tableFrais", JSON.stringify(this.tableFrais));
      data.append("rembourser", this.remboursable);
      data.append("idCond", this.condSelect);
      data.append("dateLimit", this.dateLimit);
      data.append("modeTransport", this.radioVeh);
      data.append("idVeh", this.vehSelect);
      data.append("idCaisse", this.caisseSelect);
      data.append("user", this.user.id);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "VALIDE MISSION",
            message: resp.body.message,
            type: "success",
            position: "top-right"
          });

          this.dialogDetailMission = false;
          this.dialogAccord = false;
          this.loadMissions();
        },
        resp => {
          this.$message.error("Erreur lors de la validation de mission");
          this.loading = false;
        }
      );
    },
    verifFormDmd() {
      if (
        this.formDemande.Activite != null &&
        this.formDemande.DateEntrePrevue != null &&
        this.formDemande.DateSorti != null &&
        this.formDemande.Itineraire != null &&
        this.formDemande.UserMission != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    valid2Mission() {
      this.loading = true;
      let url = this.domaine + "mission/valide/mission";
      let data = new FormData();
      data.append("idMission", this.idMission);
      data.append("etatValMiss", this.detailMission.etat);
      data.append("idVeh", this.detailMission.idVeh);
      data.append("user", this.user.id);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "VALIDE MISSION",
            message: resp.body.message,
            type: "success",
            position: "top-right"
          });

          this.dialogAccord2 = false;
          this.dialogValidMission = false;
          this.loadMissions();
        },
        resp => {
          this.$message.error("Erreur lors de la validation de mission");
          this.loading = false;
        }
      );
    },
    newDemande(formName) {
      let tel = this.user.telephone.replace(/\s+/g, '')
      this.formDemande = {
        Activite: "",
        UserMission: this.user.username,
        Itineraire: "",
        tel1: tel.length == 14 ? tel.substr(4) : tel,
        Chantier: null,
        DateSorti: null,
        DateEntrePrevue: null,
        Description: ""
      };

      this.d1 = 1;
      this.loadChantier();
      this.loadUserAdmin();
      this.dialogDemande = true;
      this.tableParticipantDemande.splice(0);
      this.isEdit = false;
      this.idEditMission = "";
    },
    next() {
      if (this.active++ > 2) this.active = 2;
    },
    prev() {
      if (this.active-- < 1) this.active = 1;
    },
    showDetailMission(item) {
      this.e1 = 1;
      this.idMission = item.IdUtil;
      this.dialogDetailMission = true;
      this.detailMission = {
        marque: item.marque,
        modele: item.modele,
        serie: item.serie,
        debut: item.debut,
        activite: item.activite,
        chantier: item.chantier,
        caisse: item.caisse,
        utilisateur: item.utilisateur,
        libEtat: item.libEtat,
        etat: item.etat,
        dateEntrePrevue: item.retour,
        dateValidation1: item.dateValidation1,
        dateValidation2: item.dateValidation2,
        distPrevue: item.distPrevue,
        itineraire: item.itineraire,
        prime: item.prime,
        fraisMission: item.fraisMission,
        fraisCarburant: item.fraisCarburant,
        kmDepart: item.kmDepart,
        niveauCarbDepart: item.niveauCarbDepart,
        fin: item.fin,
        kmRetour: item.kmRetour,
        niveauCarbRetour: item.niveauCarbRetour,
        distParcourue: item.distParcourue,
        carbConsom: item.carbConsom,
        fonction: item.fonction,
        description: item.description,
        date: item.date,
        demandeur: item.demandeur,
        IdUtil: item.IdUtil,
        idVeh: item.idVeh,
        modeTransport: item.modeTransport,
        userRapport: item.userRapport
      };
      this.tableParticipant = item.participants;
      this.tableFrais.splice(0);
      this.totalTTC = 0;
      this.totalHT = 0;
      this.totalTVA = 0;
      this.vehSelect = item.idVeh;
      this.condSelect = item.idCond;
    },
    showValidMission(item) {
      this.idMission = item.IdUtil;
      this.dialogValidMission = true;
      this.detailMission = {
        marque: item.marque,
        userRapport: item.userRapport,
        modele: item.modele,
        serie: item.serie,
        debut: item.debut,
        retour: item.retour,
        activite: item.activite,
        chantier: item.chantier,
        caisse: item.caisse,
        utilisateur: item.utilisateur,
        libEtat: item.libEtat,
        etat: item.etat,
        dateEntrePrevue: item.retour,
        dateValidation1: item.dateValidation1,
        dateValidation2: item.dateValidation2,
        distPrevue: item.distPrevue,
        itineraire: item.itineraire,
        prime: item.prime,
        fraisMission: item.fraisMission,
        fraisCarburant: item.fraisCarburant,
        kmDepart: item.kmDepart,
        kmRetour: item.kmRetour,
        niveauCarbDepart: item.niveauCarbDepart,
        fin: item.fin,
        kmRetour: item.kmRetour,
        niveauCarbRetour: item.niveauCarbRetour,
        distParcourue: item.distParcourue,
        carbConsom: item.carbConsom,
        fonction: item.fonction,
        description: item.description,
        date: item.date,
        demandeur: item.demandeur,
        IdUtil: item.IdUtil,
        nomPren: item.nomPren,
        totalFrais: item.totalFrais,
        totalFraisHT: item.totalFraisHT,
        totalTva: item.totalTva,
        validateur1: item.validateur1,
        validateur2: item.validateur2,
        idVeh: item.idVeh,
        modeTransport: item.modeTransport,
        carbConsom: item.carbConsom,
        mntCarburant: item.mntCarburant,
        imageRapport: item.imageRapport,
        rapport: item.rapport
      };

      this.tableParticipant = item.participants;
      this.tableFrais = item.frais;
    },
    loadVehiculeDisp() {
      let url = this.domaine + "mission/vehicule/disponible";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboVeh = response.body.vehicule;
        }
      });
    },
    loadChantier() {
      let url = this.domaine + "chantier/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboChantier = response.body.chantier;
        }
      });
    },
    loadCaisse() {
      let url = this.domaine + "caisse/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listeCaisse = response.body.caisse;
        }
      });
    },
    loadUserAdmin() {
      let url = this.domaine + "mission/liste/admin";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboUser = response.body.listAdmin;
        }
      });
    },
    confValMission() {
      this.dialogAccord2 = true;
    },
    imprimeMission(idEtat = 0) {
      let url =
        this.domaine +
        "mission/liste/impression/" +
        idEtat +
        "/" +
        this.user.id;
      window.open(url);
    },
    imprimeMissionExc(idEtat = 0) {
      let url = this.domaine + "mission/impressionExc/liste/" + idEtat;
      window.open(url);
    },
    editMission(item) {
      this.loadChantier();
      this.formDemande = {
        Activite: item.activite,
        UserMission: item.demandeur,
        tel1: item.telUserDemandeur,
        Itineraire: item.itineraire,
        Chantier: item.idChant,
        DateSorti: item.departFormat,
        DateEntrePrevue: item.prevueFormat,
        Description: item.description
      };
      this.tableParticipantDemande = item.participants;
      this.idEditMission = item.IdUtil;
      this.dialogDemande = true;
      this.isEdit = true;
      this.d1 = 1;
    },
    deleteMission() {
      this.loading = true;
      let url = this.domaine + "mission/" + this.MissId + "/delete";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Mission supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;
          this.loading = false;
          this.loadMissions();
          this.loading = false;
        }
      });
    },
    createDemande(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          let url = "";
          var data = new FormData();
          data.append("formDemande", JSON.stringify(this.formDemande));
          data.append("description", this.listDescription);
          data.append("participants",JSON.stringify(this.tableParticipantDemande));
          data.append("user", this.user.id);
          if (this.isEdit == true) {
            data.append("idMission", this.idEditMission);
            url = this.domaine + "mission/edit/demande";
          } else {
            url = this.domaine + "mission/create/demande";
          }
          this.$http.post(url, data).then(
            resp => {
              this.$refs["formDemande"].resetFields();
              this.loading = false;
              this.dialogDemande = false;
              this.$notify({
                title: "ENREGISTREMENT MISSION",
                message: resp.body.message,
                type: "success",
                position: "top-right",
                duration: 5000
              });

              this.loadMissions();
              this.isEdit = false;
              this.idEditMission = "";
              this.listDescription = []
            },
            resp => {
              this.$message.error(
                "Erreur lors de l'enregistrement de la demande de mission"
              );
              this.loading = false;
            }
          );
        } else {
          this.d1 = 1;
          this.$message.error(
            "Veuillez remplir correctement les champs s'il vous plait"
          );
          return false;
        }
      });
    },
    showDialogAccord() {
      if (this.caisseSelect == null && this.totalTTC > 0) {
        this.$message({
          showClose: true,
          message:
            "Veuillez selectionner une caisse pour effectuer les paiements.",
          type: "error"
        });
        return;
      }
      this.dialogAccord = true;
    },
    onFileImage1RptPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un format de fichier valide ");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.image1Rpt = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file1Rpt = files[0];
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadDemandeur(queryString, cb) {
      let url = this.domaine + "mission/listes-employe";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            var links = response.body;
            var results = queryString
              ? links.filter(this.createFilter(queryString))
              : links;
            cb(results);
          }
        },
        response => {}
      );
    }
  },
  mounted() {
    this.loadMissions();
    this.loadVehiculeDisp();
    this.loadCaisse();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/mission/Mission.vue